import React from 'react';

/**
 * Компактные вторичные бейджи политик правила в списке (ТЗ §20, §27;
 * FE-FIX17 / FE-FIX24).
 *
 * Рисуются только выключенные политики: включённое состояние — default
 * backend, и бейдж на каждой строке только зашумил бы таблицу. Отсутствующее
 * поле у старого правила трактуется как включённое, а не как «выключено».
 *
 * Политики независимы: аналитика и рассылка могут быть выключены по
 * отдельности, поэтому бейджей может быть и два.
 */
const RulePolicyBadges = ({ rule }) => (
  <>
    {rule?.include_in_analytics === false && (
      <span className="vio-badge vio-badge--policy" title="События правила не попадают в аналитику">
        Без аналитики
      </span>
    )}
    {rule?.notifications_enabled === false && (
      <span className="vio-badge vio-badge--policy" title="Email и web push по правилу не отправляются">
        Без рассылки
      </span>
    )}
  </>
);

export default RulePolicyBadges;
